import { jsx as e } from "react/jsx-runtime";
import d from "react";
import t from "styled-components";
const n = t.div.withConfig({
  displayName: "Popover",
  componentId: "sc-5ntbq0-0"
})(["display:block;box-sizing:border-box;padding:var(--spacing-2x);border-radius:var(--default-border-radius);border:var(--default-border-width) solid var(--elements-border-color);background-color:var(--elements-bg-color-01);box-shadow:var(--shadow-level-1);height:auto;width:auto;"]), i = d.forwardRef(({
  children: o,
  ...r
}, a) => /* @__PURE__ */ e(n, { ref: a, className: "rango-popover", "data-testid": "rango-popover", "data-rango-component": "rango-popover", "data-is-rango": !0, ...r, children: o }));
i.displayName = "RangoPopover";
export {
  i as RangoPopover
};
